import { render } from "./ButtonToTop.vue?vue&type=template&id=6d5176c6&scoped=true"
import script from "./ButtonToTop.vue?vue&type=script&lang=js"
export * from "./ButtonToTop.vue?vue&type=script&lang=js"

import "./ButtonToTop.vue?vue&type=style&index=0&id=6d5176c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5176c6"]])

export default __exports__